export class EnderecoTipo {
  id: number;
  descricao: string;

  constructor(enderecoTipo?: EnderecoTipo | number) {
    if (enderecoTipo !== undefined && enderecoTipo !== null) {
      if (typeof enderecoTipo === 'number') {
        this.id = enderecoTipo;
      } else {
        this.id = enderecoTipo.id;
        this.descricao = enderecoTipo.descricao;
      }
    }
  }
}
